import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './images/ava.png'
import _imports_1 from './images/video.png'


_pushScopeId("data-v-3f4a4340")
const _hoisted_1 = { class: "kol" }
const _hoisted_2 = { class: "kol__hd" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" — ")
const _hoisted_4 = { class: "kol__bd" }
const _hoisted_5 = { class: "kol__bd-left" }
const _hoisted_6 = { class: "kol-tips" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "wg" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  width: "28"
}, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  width: "28"
}, null, -1)
const _hoisted_11 = { class: "kol-btns" }
const _hoisted_12 = { class: "kol__bd-right" }
const _hoisted_13 = { class: "carousel" }
const _hoisted_14 = { class: "carousel-preview" }
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "carousel-indicator" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = ["src"]
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", null, _toDisplayString(_ctx.lang('kol.tit.h3')), 1),
      _createElementVNode("p", null, [
        _hoisted_3,
        _createElementVNode("span", null, _toDisplayString(_ctx.lang('kol.vice[1]')), 1),
        _createTextVNode(" " + _toDisplayString(_ctx.lang('kol.vice[2]')) + " —", 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("h4", null, _toDisplayString(_ctx.lang('kol.tit.h4')), 1),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("ul", null, [
            _createElementVNode("li", null, _toDisplayString(_ctx.lang('kol.tit.tips[1]')), 1),
            _createElementVNode("li", null, [
              _hoisted_8,
              _createTextVNode(" " + _toDisplayString(_ctx.lang('kol.tit.tips[2]')), 1),
              _hoisted_9,
              _createTextVNode(" " + _toDisplayString(_ctx.lang('kol.tit.tips[3]')), 1),
              _createElementVNode("strong", null, _toDisplayString(_ctx.lang('kol.tit.tips[4]')), 1)
            ]),
            _createElementVNode("li", null, [
              _hoisted_10,
              _createTextVNode(" " + _toDisplayString(_ctx.lang('kol.tit.tips[5]')), 1),
              _createElementVNode("strong", null, _toDisplayString(_ctx.lang('kol.tit.tips[6]')), 1),
              _createTextVNode(" " + _toDisplayString(_ctx.lang('kol.tit.tips[7]')), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_el_button, {
            onClick: _ctx.apply,
            type: "primary",
            size: "large"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.lang('kol.btn.apply')), 1)
            ]),
            _: 1
          }, 8, ["onClick"]),
          (_ctx.showShare)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                onClick: _ctx.share,
                size: "large",
                style: {"color":"#0ba2f9"}
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.lang('kol.btn.invite')), 1)
                ]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("video", {
              id: "videoPlayer",
              src: _ctx.currentVideo.video,
              preload: "auto",
              loop: "",
              autoplay: "",
              muted: "",
              controls: ""
            }, null, 8, _hoisted_15)
          ]),
          _createElementVNode("div", _hoisted_16, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.videoData, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                onClick: ($event: any) => (_ctx.selectHandle(item)),
                class: _normalizeClass(['carousel-indicator__item', { active: item.id === _ctx.currentVideo.id }])
              }, [
                _createElementVNode("img", {
                  src: item.url,
                  alt: ""
                }, null, 8, _hoisted_18),
                _createElementVNode("p", null, [
                  _createElementVNode("i", {
                    class: _normalizeClass(
                    _ctx.currentVideo.id === item.id && _ctx.videoStatus === 'playing' ? 'play' : 'pause'
                  )
                  }, null, 2),
                  _createTextVNode(_toDisplayString(item.title), 1)
                ])
              ], 10, _hoisted_17))
            }), 128))
          ])
        ])
      ])
    ])
  ]))
}